export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5292.eab396a2.jpg";